<template>
    <div class="container">
      <div class="title">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>业务管理</el-breadcrumb-item>
          <el-breadcrumb-item>PO管理</el-breadcrumb-item>
          <el-breadcrumb-item>PO需求</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="title-en">搜索条件</div>
      <el-card class="box-card">
        <div class="search-container">
          <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="建单时间">
                  <el-date-picker
                    v-model="searchForm.createTime"
                    type="daterange"
                    range-separator="-"
                    style="width: 100%"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="handleDateChange"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="工单类型">
                  <el-select
                    clearable
                    v-model="searchForm.order_level"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in category_level_4Options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="PO单号">
                  <el-input v-model="searchForm.opTicketid" placeholder="请输入PO单号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="PO标题">
                  <el-input v-model="searchForm.memo" placeholder="请输入PO标题"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="区域园区">
                  <el-select clearable v-model="searchForm.campusName" placeholder="请选择" @focus="handleSelectFocus">
                  <el-option
                    v-for="(item, index) in campusOptions"
                    :key="index"
                    :label="Object.values(item)[0]"
                    :value="Object.values(item)[0]"
                  ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="工单等级">
                  <el-select clearable v-model="searchForm.SlALevel" placeholder="请选择">
                    <el-option label="重要的" value="0"></el-option>
                    <el-option label="一级" value="1"></el-option>
                    <el-option label="二级" value="2"></el-option>
                    <el-option label="三级" value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="派单状态">
                  <el-select clearable v-model="searchForm.state" placeholder="请选择">
                    <el-option label="已派单" value="已派单"></el-option>
                    <el-option label="待派单" value="待派单"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="工单单号">
                  <el-input v-model="searchForm.ticket_id" placeholder="请输入工单单号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <div class="search-button">
                  <el-button type="primary" @click="handleSearch">点击查询</el-button>
                  <el-button @click="handleReset">重置</el-button>
                  <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
      <div class="title-en">PO需求</div>
  
      <el-card class="box-card">
        <div class="table-container">
          <div class="button-container">
            <el-button @click="openColumnsDialog">表头设置</el-button>
          </div>
          <el-table
            :data="faults"
            border
            stripe
            @selection-change="handleSelectionChange"
            ref="table"
            v-loading="loading"
          >
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column
              v-for="(column, index) in visibleColumns"
              :key="index"
              :prop="column.prop"
              :label="column.label"
              :width="column.width"
            >
              <template slot-scope="scope">
                <span v-if="column.prop === 'poType'">{{ '已确认' }}</span>
                <span v-else-if="column.prop === 'isAccepted'">{{
                  scope.row[column.prop] === 1
                    ? '已收单'
                    : scope.row[column.prop] === 0
                    ? '已拒单'
                    : '待确认'
                }}</span>
                <span v-else-if="column.prop === 'createTime'">{{
                  scope.row[column.prop]
                    ? $moment(scope.row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                    : '-'
                }}</span>
                <span v-else-if="column.prop === 'dispatchType'">{{ '人工派单' }}</span>
                <span v-else-if="column.prop === 'dispatchStatus'">{{
                  scope.row.engineerName ? '已派单' : '待派单'
                }}</span>
                <span v-else-if="column.prop === 'opTicketid'">
                  <a
                    :href="
                      scope.row.isAccepted === 0 || scope.row.isAccepted === 1
                        ? `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}&isHistory=1`
                        : `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}`
                    "
                    target="_blank"
                    >{{ scope.row.opTicketid }}</a
                  >
                </span>
                <span v-else-if="column.prop === 'campusName'">{{
                  scope.row.campusName === '张家口-怀来东园'
                    ? '怀来-东园'
                    : scope.row[column.prop] || '-'
                }}</span>
                <span v-else-if="column.prop === 'memo'">{{
                  'PO确认单-' + (scope.row[column.prop] || '-')
                }}</span>
                <span v-else>{{ scope.row[column.prop] || '-' }}</span>
              </template>
            </el-table-column>
          </el-table>
  
          <el-dialog
            title="设置显示项"
            :visible.sync="showColumnsDialog"
            :append-to-body="true"
            width="400px"
            :close-on-click-modal="false"
            custom-class="columns-dialog"
            :modal-append-to-body="false"
            :destroy-on-close="true"
          >
            <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
              <el-checkbox
                v-for="column in columns"
                :key="column.prop"
                :label="column.prop"
                class="checkbox-item"
              >
                {{ column.label }}
              </el-checkbox>
            </el-checkbox-group>
            <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="selectAllColumns">全选</el-button>
              <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
              <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
            </div>
          </el-dialog>
  
          <div class="pagination-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            />
          </div>
        </div>
      </el-card>
    </div>
  </template>
      
      <script>
  import { getPoList, exportPoList } from '@/api/appManage';
  import { getMachineList } from '@/api/workOrder';
  import * as XLSX from 'xlsx';
  import { debounce } from 'lodash';
  import { getCampusList } from '@/api/operation';
  export default {
    name: 'FaultList',
    data() {
      return {
        debouncedExport: null,
        faults: [],
        searchForm: {
          createTime: [],
          order_level: '',
          opTicketid: '',
          memo: '',
          campusName: '',
          sla_level: '',
          state: '',
          ticket_id: '',
        },
        campusOptions: [], // 用于存储园区接口返回的数据
        hasLoaded: false, // 添加标志位防止重复加载
        category_level_4Options: [
          { value: '1', label: '服务器' },
          { value: '2', label: '网络' },
          { value: '4', label: '其它' },
        ],
        campusNameOptions: [
          { value: 'sh-lg', label: '上海-临港' },
          { value: 'sh-sy', label: '上海-书院' },
          { value: 'hz-dg', label: '杭州-东冠' },
        ],
        currentPage: 1,
        pageSize: 10,
        total: 0,
        showColumnsDialog: false,
        selectedColumns: [
          'opTicketid',
          'ticketId_waitTodo',
          'memo',
          'category_level_4',
          'sla_level',
          'campusName',
          'num',
          'createTime',
          'isAccepted',
          'dispatchType',
          'dispatchStatus',
        ],
        defaultSelectedColumns: [
          'opTicketid',
          'memo',
          'ticketId_waitTodo',
          'category_level_4',
          'sla_level',
          'campusName',
          'num',
          'createTime',
          'isAccepted',
          'dispatchType',
          'dispatchStatus',
        ],
        columns: [
          { prop: 'opTicketid', label: 'PO单号', width: 130 },
          { prop: 'ticketId_waitTodo', label: '工单单号', width: 130 },
          { prop: 'memo', label: 'PO标题', width: 280 },
          { prop: 'category_level_4', label: '工单类型' },
          { prop: 'sla_level', label: '工单等级', width: 70 },
          { prop: 'campusName', label: '区域-园区' },
          { prop: 'num', label: '设备数量', width: 70 },
          { prop: 'createTime', label: '建单时间', width: 150 },
          { prop: 'isAccepted', label: '响应状态' },
          { prop: 'dispatchStatus', label: '派单状态' },
          { prop: 'dispatchType', label: '派单形式' },
        ],
        visibleColumns: [],
        selectedRows: [],
        machineList: [],
        loading: false,
      };
    },
    created() {
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
      
      this.fetchFaultData();
      // 创建防抖后的导出函数
      this.debouncedExport = debounce(this.handleExport, 300);
    },
    methods: {
      //园区获取数据接口
    async getCampusData() {  
      try {
        const params = {
          spec_sign: 0,
        };
        const response = await getCampusList(params);
        if (response.data && response.data.code === 200) {
          this.campusOptions = response.data.data; 
          this.hasLoaded = true;
          //console.log("成功设置 campusOptions:", this.campusOptions)
        } else {
          console.warn("接口返回状态码不正确:", response.data?.code)
        }
      } catch (error) {
        console.error('获取园区数据失败:', error);
      }
    },
    // focus 事件处理园区获取数据
    handleSelectFocus() {
      if (!this.hasLoaded) {
        this.getCampusData();
      }
    },
      handleDateChange(dates) {
        if (dates) {
          this.searchForm.start_time = dates[0];
          this.searchForm.end_time = dates[1] + ' 23:59:59';
        } else {
          this.searchForm.start_time = '';
          this.searchForm.end_time = '';
        }
      },
      getMachineLists() {
        const params = {
          page: this.currentPage,
          size: this.pageSize,
        };
        getMachineList(params)
          .then((res) => {
            this.machineList = res.data.data.list || [];
          })
          .catch(() => {
            this.$message.error(errorMessage);
          });
      },
      async fetchFaultData() {
        const params = {
          page: this.currentPage,
          size: this.pageSize,
          ...Object.fromEntries(
            Object.entries(this.searchForm).filter(
              ([_, value]) => value !== '' && value !== null && value !== undefined
            )
          ),
        };
        // 处理日期范围
        if (this.searchForm.createTime && this.searchForm.createTime.length === 2) {
          params.start_time = this.searchForm.createTime[0];
          params.end_time = this.searchForm.createTime[1];
        }
        this.loading = true;
  
        try {
          let response;
          // 添加结束时间的时分秒
          if (params.end_time) {
            params.end_time = params.end_time + ' 23:59:59';
          }
          // 使用常规的getPoList进行查询
          response = await getPoList(params);
  
          if (response.data) {
            let filteredData = [];
            this.faults = filteredData;
            this.total = response.data.data.total || 0;
          }
        } catch (error) {
          console.error('请求错误:', error);
          let errorMessage = '获取数据失败';
          if (error.response && error.response.status === 422) {
            errorMessage = '请求参数格式不正确，请检查输入';
          }
          this.$message.error(errorMessage);
        } finally {
          this.loading = false;
        }
      },
      handleSearch() {
        // 处理PO标题前缀
        if (this.searchForm.memo && this.searchForm.memo.startsWith('PO确认单-')) {
          this.searchForm.memo = this.searchForm.memo.replace('PO确认单-', '');
        }
        this.currentPage = 1;
        this.fetchFaultData();
      },
      handleReset() {
        this.searchForm = {
          createTime: [],
          order_level: '',
          opTicketid: '',
          memo: '',
          campusName: '',
          sla_level: '',
          state: '',
          ticket_id: '',
        };
        const endDate = new Date();
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 1);
        this.searchForm.createTime = [
          this.$moment(startDate).format('YYYY-MM-DD'),
          this.$moment(endDate).format('YYYY-MM-DD'),
        ];
        this.handleDateChange(this.searchForm.createTime);
        this.currentPage = 1;
        this.fetchFaultData();
      },
      openColumnsDialog() {
        this.showColumnsDialog = true;
      },
      saveColumnsDialog() {
        this.showColumnsDialog = false;
        this.visibleColumns = this.columns.filter((column) =>
          this.selectedColumns.includes(column.prop)
        );
      },
      selectAllColumns() {
        this.selectedColumns = this.columns.map((column) => column.prop);
      },
      restoreDefaultColumns() {
        this.selectedColumns = [...this.defaultSelectedColumns];
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.fetchFaultData();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.fetchFaultData();
      },
      handleSelectionChange(selection) {
        this.selectedRows = selection;
      },
      async handleExport() {
        this.exportLoading = true;
        try {
          if (this.selectedRows.length === 0) {
            // 导出全部数据
            this.loading = true;
            const response = await exportPoList({
              ...Object.fromEntries(
                Object.entries(this.searchForm).filter(
                  ([_, value]) => value !== '' && value !== null && value !== undefined
                )
              ),
              pageSize: this.total || 9999999, // 确保获取所有数据
              currentPage: 1,
            });
  
            if (response.data) {
              this.loading = false;
              const allData = response.data.data.list || [];
              // 转换数据格式，确保与表格显示一致
              const worksheetData = allData.map((row) => {
                const rowData = {};
                this.visibleColumns.forEach((column) => {
                  if (column.prop !== 'operation') {
                    // 排除操作列
                    let value = row[column.prop];
                    // 特殊字段处理，与表格显示保持一致
                    if (column.prop === 'poType') {
                      value = '已确认';
                    } else if (column.prop === 'isAccepted') {
                      value = row[column.prop] === 1 ? '已结单' : '待结单';
                    } else if (column.prop === 'createTime') {
                      value = row[column.prop]
                        ? this.$moment(row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                        : '-';
                    } else if (column.prop === 'dispatchType') {
                      value = '人工派单';
                    } else if (column.prop === 'dispatchStatus') {
                      value = row.engineerName ? '已派单' : '待派单';
                    } else if (column.prop === 'memo') {
                      value = value ? `PO确认单-${value}` : '-';
                    }
                    rowData[column.label] = value || '-';
                  }
                });
                return rowData;
              });
  
              // 创建工作簿和工作表
              const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  
              // 设置列宽
              const colWidths = {};
              this.visibleColumns.forEach((column, index) => {
                const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
                colWidths[XLSX.utils.encode_col(index)] = { wch: width };
              });
              worksheet['!cols'] = Object.values(colWidths);
  
              const workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, 'PO需求');
  
              // 生成文件名
              const timestamp = this.$moment().format('YYYYMMDDHHmmss');
              const filename = `PO需求_${timestamp}.xlsx`;
  
              // 导出文件
              XLSX.writeFile(workbook, filename);
              this.$message.success('导出成功');
            }
          } else {
            // 导出选中数据的逻辑保持不变
            const worksheetData = this.selectedRows.map((row) => {
              const rowData = {};
              this.visibleColumns.forEach((column) => {
                if (column.prop !== 'operation') {
                  // 排除操作列
                  let value = row[column.prop];
                  if (column.prop === 'poType') {
                    value = '已确认';
                  } else if (column.prop === 'isAccepted') {
                    value = row[column.prop] === 1 ? '已结单' : '待结单';
                  } else if (column.prop === 'createTime') {
                    value = row[column.prop]
                      ? this.$moment(row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                      : '-';
                  } else if (column.prop === 'dispatchType') {
                    value = '人工派单';
                  } else if (column.prop === 'dispatchStatus') {
                    value = row.engineerName ? '已派单' : '待派单';
                  } else if (column.prop === 'memo') {
                    value = value ? `PO确认单-${value}` : '-';
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });
  
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  
            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);
  
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'PO需求');
  
            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `PO需求_${timestamp}.xlsx`;
  
            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } catch (error) {
          console.error('导出错误:', error);
          this.$message.error('导出失败，请重试');
        } finally {
          this.exportLoading = false;
          this.loading = false;
        }
      },
    },
    computed: {
      exportButtonText() {
        return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
      },
    },
    watch: {
      selectedColumns(val) {
        this.selectAll = val.length === this.columns.length;
        this.isIndeterminate = val.length > 0 && val.length < this.columns.length;
      },
    },
  };
  </script>
      
      <style scoped>
  .container {
    padding: 20px;
  }
  .title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .search-container {
    padding: 20px;
    background-color: #fff;
    border-radius: 4px;
  }
  
  .search-form {
    width: 100%;
  }
  
  .search-button {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-left: 13px;
  }
  
  /* 调整表单项间距 */
  .el-form-item {
    margin-bottom: 18px;
    display: flex;
  }
  
  .button-container {
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
    position: relative;
  }
  .box-card {
    margin-bottom: 20px;
  }
  .pagination-container {
    display: flex;
    justify-content: flex-end;
  }
  .title-en {
    margin: 10px 0;
    padding-left: 10px;
    border-left: 3px solid #219aff;
    font-weight: normal;
  }
  .columns-dialog {
    margin-top: 0 !important;
    position: absolute !important;
    margin-left: 0 !important;
    top: 100% !important;
    left: 0 !important;
    transform: none !important;
  }
  
  .el-dialog__wrapper.columns-dialog {
    position: absolute !important;
    overflow: visible !important;
  }
  
  .button-container {
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
    position: relative;
  }
  .checkbox-group {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    padding: 10px;
    max-height: 300px;
    overflow-y: auto;
  }
  
  .checkbox-item {
    margin-right: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .dialog-footer {
    text-align: right;
    padding-top: 15px;
    border-top: 1px solid #ebeef5;
  }
  
  .dialog-footer .el-button + .el-button {
    margin-left: 8px;
  }
  
  /* 修改日期选择器宽度 */
  ::v-deep .el-date-editor.el-input__inner,
  .el-date-editor--daterange.el-input__inner {
    width: 100% !important;
  }
  
  ::v-deep .el-range-editor.el-input__inner {
    width: 100% !important;
  }
  ::v-deep .el-date-editor .el-range-input {
    width: 66% !important;
  }
  ::v-deep .el-range-editor--small .el-range-input {
    font-size: 12px !important;
  }
  /* 统一下拉框和输入框宽度 */
  ::v-deep .el-select,
  .el-input {
    width: 100% !important;
  }
  ::v-deep .el-form-item__content {
    width: calc(100% - 10px) !important;
  }
  
  /* PO单号链接样式 */
  ::v-deep .el-table a {
    color: #409eff;
    text-decoration: none;
    font-weight: 500;
  }
  
  ::v-deep .el-table a:hover {
    color: #66b1ff;
    text-decoration: underline;
    font-weight: 500;
  }
  </style>